<template>
  <div class="col-12">
    <b-row>
      <div class="col-12">
        <b-form-group label="Send CC to" label-cols="2">
          <b-form-input v-model="mail_cc" @change="savefield('g_adminmailtexts',mailtext_id,'mail_cc',mail_cc)"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-12">
        <b-form-group label="Mail subject" label-cols="2">
          <b-form-input v-model="mailtext_subject" @change="savefield('g_adminmailtexts',mailtext_id,'mailtext_subject',mailtext_subject)"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-12">
        <b-form-group label="Body text (a link to the 'Reset Password' page is added automatically)">
          <vue-editor v-model="mailtext_text" :editorToolbar="editortoolbar" @text-change="savefield('g_adminmailtexts',mailtext_id,'mailtext_text',mailtext_text)"></vue-editor>
        </b-form-group>
      </div>
      <div class="form-group col-12 mt-4">
        <b-button 
          v-if="mailtext_id < 1" 
          @click.prevent="mailtext_create" 
          class="mt-10"
          variant="primary"
        >
          Save New Mail Text
        </b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
];

export default {
  components: {
    VueEditor,
  },
  name: 'DefaultMailNewUser',
  mounted() {
    this.mailtext_get();
  },
  data: function() {
    return {
      editortoolbar: editortools,
      mailtype_id: 1,
      mailtext_id: 0,
      mailtext_subject: '',
      mailtext_text: '',
      mail_cc: '',
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    mailtext_get() {
      var filter = {
        mailtype_id: {
          operator: '=',
          value: this.mailtype_id,
        },
      }
      this.$store.dispatch('adminmailtext_fetch', { filter: filter })
      .then((resp) => {
        if (resp.data.total > 0) {
          var mailtext = resp.data.result[0];
          this.mailtext_id = mailtext.id;
          this.mailtext_subject = mailtext.mailtext_subject;
          this.mailtext_text = mailtext.mailtext_text;
          this.mail_cc = mailtext.mail_cc;
        } else {
          this.mailtext_id = 0;
          this.mailtext_subject = '';
          this.mailtext_text = '';
          this.mail_cc = '';
        }
      });
    },
    mailtext_create() {
      var adminmailtext =  {
        id: this.mailtext_id,
        mailtype_id: this.mailtype_id,
        mailtext_subject: this.mailtext_subject,
        mailtext_text: this.mailtext_text,
        mail_cc: this.mail_cc,
      }
      this.$store.dispatch('adminmailtext_create', { adminmailtext: adminmailtext })
      .then((resp) => {
        this.mailtext_id = resp.data.id;
      })
    },
    checkform() {
      return true;
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
        }
      }
    },
  }
}
</script>
<style>
</style>
